/** Mensagens rápidas padrão para comunicação interna no consultório. */
export interface TeamChatQuickMessage {
  id: string;
  name: string;
  message: string;
}

export const TEAM_CHAT_DEFAULT_QUICK_MESSAGES: TeamChatQuickMessage[] = [
  {
    id: 'next-patient',
    name: 'Próximo paciente',
    message: 'Por favor, liberar a entrada do próximo paciente na sala.',
  },
  {
    id: 'patient-reception',
    name: 'Paciente na recepção',
    message: 'Paciente aguardando na recepção. Podem recebê-lo?',
  },
  {
    id: 'room-ready',
    name: 'Consultório pronto',
    message: 'Consultório pronto. Pode encaminhar o próximo paciente.',
  },
  {
    id: 'running-late',
    name: 'Atraso no atendimento',
    message: 'Estou com atraso no atendimento. Peço gentileza para aguardar alguns minutos.',
  },
  {
    id: 'need-help',
    name: 'Preciso de ajuda',
    message: 'Preciso de ajuda na sala de atendimento, por favor.',
  },
  {
    id: 'break',
    name: 'Intervalo',
    message: 'Entrando em intervalo. Retorno em aproximadamente 15 minutos.',
  },
  {
    id: 'no-show',
    name: 'Paciente faltou',
    message: 'Paciente não compareceu ao horário agendado.',
  },
  {
    id: 'exam-referral',
    name: 'Encaminhar exame',
    message: 'Paciente liberado para exame complementar. Favor aguardar orientação.',
  },
  {
    id: 'payment-desk',
    name: 'Passar no caixa',
    message: 'Paciente liberado. Favor orientar a passar no caixa antes de sair.',
  },
  {
    id: 'documents-ready',
    name: 'Documentos prontos',
    message: 'Documentos do paciente prontos para retirada/impressão.',
  },
];
